__turbopack_context__.v({
  "buttonClassDetails": "Yd4VfG_buttonClassDetails",
  "classDetailsDescription": "Yd4VfG_classDetailsDescription",
  "container": "Yd4VfG_container",
  "content": "Yd4VfG_content",
  "header": "Yd4VfG_header",
  "isBack": "Yd4VfG_isBack",
  "isDetails": "Yd4VfG_isDetails",
  "isHidden": "Yd4VfG_isHidden",
  "left": "Yd4VfG_left",
  "mainHeader": "Yd4VfG_mainHeader",
  "right": "Yd4VfG_right",
  "title": "Yd4VfG_title",
});
